import { cloneDeep, omit } from 'lodash-es';

import {
  fetch,
  request,
  buildQueryString,
} from '../utils/request';

const PANELS_BASE = process.env.TAGBOARD_PANELS_URL;

const PanelsService = {
  getUserSmartPanels(owner, opts = {}) {
    const query = { ...opts, scope: 'producer' };
    return fetch(`${PANELS_BASE}/panels/${owner}${buildQueryString(query)}`);
  },

  getMultiple(owner, panelIds = []) {
    if (!panelIds.length) {
      return { panels: [] };
    }

    const query = {
      panels: panelIds.join(','),
    };

    return fetch(`${PANELS_BASE}/panels/${owner}${buildQueryString(query)}`);
  },

  createPanel(obj) {
    const panel = cloneDeep(obj);

    return request({
      type: 'POST',
      contentType: 'application/json',
      url: `${PANELS_BASE}/panel/create`,
      data: JSON.stringify(panel),
    });
  },

  editPanel(obj) {
    const id = obj._id;
    const panel = cloneDeep(omit(obj, ['_id', 'created_time', 'last_updated', 'created_by']));

    return request({
      type: 'PUT',
      url: `${PANELS_BASE}/panel/${id}`,
      contentType: 'application/json',
      data: JSON.stringify(panel),
    });
  },
};

export default PanelsService;
